import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import classNames from 'classnames';
import moment from 'moment';
import { isFunction, pick, omit } from 'lodash';
import AirButton from '../../../../common/components/AirButton';
import AirModalTitlebar from '../../../../common/components/AirModalTitlebar';
import { VehicleAddIcon } from '../../../../common/icons';
import AirInput from '../../../../common/components/AirInput';
import { Checkbox, Select, Spin, Tooltip } from 'antd';
import { api } from '../../../../services';
import RequestSelect from './RequestSelect';
import InstallerPicker from './InstallerPicker';

import './NewConnectionRequest.css';
import FreeSubscriptionPicker from "./FreeSubscriptionPicker";

const { Option } = Select;

const NewConnectionRequestSection = ({ children, title, ...props }) => (
  <div {...props} className={`NewConnectionRequestSection${props.className ? ` ${props.className}` : ''}`}>
    <div className="SectionTitle">{title}</div>
    <div className="SectionContent">{children}</div>
  </div>
);

@inject('translationsStore', 'commonStore', 'connectionRequestsStore', 'subscriptionsStore')
@observer
export default class NewConnectionRequest extends Component {
  constructor(props) {
    super(props);
    this.defaultVehicleDataValues = {
      license_plate: undefined,
      brand: undefined,
      brands: undefined,
      model: undefined,
      models: undefined,
      variants: undefined,
      variant: undefined,
      registration_date: undefined,
      vin: undefined,
      fuel_type: undefined,
      displacement: undefined
    };
    this.state = {
      loadingResources: false,
      availableProducts: [],
      product_uuid: undefined,
      availableSubscriptionTypes: [],
      availableSubscriptionTypesForProduct: [],
      subscription_type_uuid: undefined,
      availableAddOns: [],
      addOns: undefined,
      availableInstallers: [],
      installer_uuid: undefined,
      visibleInstallerPicker: false,
      ...this.defaultVehicleDataValues,
      availableFuelType: ['diesel', 'petrol', 'hybrid', 'LPG', 'natural_gas', 'other', 'unknown'],
      visibleModalError: false,
      modalError: undefined
    };
    this.showAddOnsBySku = ['BLCMTR'];
    this.fuelTypes = [
      { type: 'petrol', alias: ['petrol', 'pertrol', 'benzina'] },
      { type: 'diesel', alias: ['diesel'] },
      { type: 'natural_gas', alias: ['methan', 'metano'] },
      { type: 'LPG', alias: ['LPG', 'gpl'] },
      { type: 'hybrid', alias: ['hybrid', 'ibrida'] },
      { type: 'other', alias: ['other', 'elettrica', 'altro'] }
    ];
  }

  componentDidMount = () => {
    this.loadResources();
  };

  loadResources = () => {
    this.setState({ loadingResources: true });
    const { commonStore } = this.props,
      {
        dealer: { masterApiUserUuid: uuid }
      } = commonStore;
    const p1 = api('getConnectionRequestProducts');
    const p2 = api('getConnectionRequestFleetCustomerDetails', uuid);
    Promise.all([p1, p2])
      .then(([allProducts, fleetCustomer]) => {
        allProducts = allProducts
          .filter(product => {
            return product.zuora_product_id
          })
          .map(product => {
            product = pick(product, ['id', 'uuid', 'name', 'category', 'description', 'features', 'productRatePlans', 'availability']);
            product.features = product.features.map(feature => pick(feature.node, ['id', 'uuid', 'name']));
            product.productRatePlans = product.productRatePlans.map(ratePlan => pick(ratePlan, ['id', 'name', 'productRatePlanCharges', 'duration__c', 'ChargeModel__c']));
            return product;
          })
          .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
        const duration = (fleetCustomer.subscriptionTypes && fleetCustomer.subscriptionTypes[0] && fleetCustomer.subscriptionTypes[0].duration) || 24;

        this.setState({allProducts});

        let { products: availableProducts, installers: availableInstallers, subscriptionTypes: availableSubscriptionTypes } = fleetCustomer;
        let availableAddOns = [
          // { uuid: '541ee421-f807-4fd3-9827-8c7da770ce92', name: 'manage_engine', sku: 'BLCMTR', zuora_product_id: '2c92c0f96fd667f3016fe792f665643b', category: 'add-on' }
        ];
        availableProducts = availableProducts
          .filter(productRel => {
            const productWithRatePlans = allProducts.find(prod => prod.id === productRel.node.zuora_product_id);

            if (!productWithRatePlans){
              return false;
            } else {
              return productWithRatePlans.productRatePlans.find(ratePlan => ratePlan.duration__c == duration);
            }
          })
          .map(type => pick(type.node, ['uuid', 'name', 'zuora_product_id', 'category']))
          // .map(type => pick(type.node, ['uuid', 'name', 'zuora_product_id', 'category', 'features']))
          .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
        availableInstallers = availableInstallers.map(type => omit(type.node, ['_id', '_labels'])).sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
        availableSubscriptionTypes = availableSubscriptionTypes.map(type => pick(type.node, ['uuid', 'name'])).sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
        availableAddOns.filter(addOn => this.showAddOnsBySku.includes(addOn.sku));
        this.setState({ availableProducts, availableInstallers, availableSubscriptionTypes, availableAddOns, duration });
      })
      .catch(error => ({ error }))
      .finally(() => this.setState({ loadingResources: false }));
  };

  queryTechnicalDetails = id => {
    this.setState({ loadingResources: true });
    return api('getConnectionRequestVehicleTechnicalDetails', id)
      .then(technicalDetails => {
        let {
          data: {
            attributes: {
              technical_details: {
                motore: { cilindrata: displacement, alimentazione: fuel_type },
              }
            }
          }
        } = technicalDetails;
        displacement = Number(displacement);
        fuel_type = this.fuelTypes.find(type => type.alias.includes(fuel_type.toLowerCase())).type;
        return { displacement, fuel_type };
      })
      .finally(() => this.setState({ loadingResources: false }));
  };

  onProductChange = product_uuid => {

    const productWithRatePlans = this.state.allProducts.find(prod => prod.uuid === product_uuid);
    const availableSubscriptionTypesForProduct = this.state.availableSubscriptionTypes.filter(subscriptionType => productWithRatePlans.productRatePlans.find(ratePlan => ratePlan.ChargeModel__c === subscriptionType.name && ratePlan.duration__c == this.state.duration))

    this.setState({
      product_uuid,
      availableSubscriptionTypesForProduct
    });
  };

  onSubscriptionTypeChange = subscription_type_uuid => {

    const subscriptionType = this.state.availableSubscriptionTypesForProduct.find(subType => subType.uuid === subscription_type_uuid);

    let availableAddOns = [];

    if (this.state.allProducts.find(el=> el.uuid === this.state.product_uuid).features.some(feature => feature.name==='engine-control')) {
      availableAddOns = this.state.allProducts.filter(el => el.category === 'add-on' && el.features.some(feature => feature.name==='engine-control') && el.productRatePlans.find(ratePlan => ratePlan.duration__c == this.state.duration && ratePlan.ChargeModel__c === subscriptionType.name));
    }

    this.setState({ subscription_type_uuid, availableAddOns });
  };

  onAddOnsChange = addOns => {
    this.setState({
      addOns
    });
  };

  onInstallerChange = installer_uuid => {
    this.setState({ installer_uuid });
  };

  onInstallerVisibleChange = visible => {
    if (visible) {
      this.setState({
        visibleInstallerPicker: visible
      });
    }
  };

  onInstallerPickerCancel = () => {
    this.setState({
      visibleInstallerPicker: false
    });
  };

  onPlateChange = e => {
    this.setState({
      license_plate: String(e.target.value).toUpperCase()
    });
  };

  loadManualForm = () => {
    return api('getConnectionRequestVehicleBrands')
      .then(res => {
        const data = res.data;
        data.push({ id: 0, attributes: { name: this.props.translationsStore.translate('connectionRequests.newConnection.sectionVehicleData.labelOther') } });
        this.setState({brands: data.map(model => ({id: model.id, name: model.attributes.name}))});
      })
      .catch(error => ({ error }));
  }

  onPlateQueryClick = () => {
    this.setState({
      loadingResources: true,
      brand: undefined,
      brands: undefined,
      isOtherBrand: false,
      otherBrand: undefined,
      model: undefined,
      models: undefined,
      isOtherModel: false,
      otherModel: undefined,
      variant: undefined,
      variants: undefined,
      isOtherVariant: false,
      otherVariant: undefined,
      registration_date: undefined,
      vin: undefined,
      fuel_type: undefined,
      displacement: undefined
    });
    const { license_plate } = this.state;
    api('getConnectionRequestVehicleInfocarData', license_plate)
      .then(async data => {
        const {brand, model, variants, registration_date, vin, fuel_type,} = data.data.attributes;

        let vehicleData = {
          brand,
          model,
          variants,
          registration_date,
          vin,
          fuel_type,
          variant: undefined,
          displacement: undefined
        };

        if (variants.length === 1) {
          vehicleData = { ...vehicleData, variant: variants[0] };
          await this.queryTechnicalDetails(vehicleData.variant.id)
            .then(technicalDetails => {
              const { fuel_type, displacement } = technicalDetails;
              vehicleData = { ...vehicleData, fuel_type, displacement };
            })
            .catch(error => ({ error }));
        }
        this.setState({ ...vehicleData });
      })
      .catch(async error => await this.loadManualForm())
      .finally(() => this.setState({ loadingResources: false }));
  };

  validBrand = () => {
    if (this.state.isOtherBrand === true && this.state.otherBrand !== undefined && this.state.otherBrand !== '') {
      return true;
    } else if (this.state.isOtherBrand === false && this.state.brand !== undefined) {
      return true;
    } else {
      return false;
    }
  }

  onBrandChange = brand => {
    this.setState({ loadingResources: true, brand: JSON.parse(brand), models: undefined, model: undefined,  variants: undefined, variant: undefined });
    const { id, name } = JSON.parse(brand);
    if (name !== this.props.translationsStore.translate('connectionRequests.newConnection.sectionVehicleData.labelOther')) {
      this.setState({ isOtherBrand: false, otherBrand: undefined, isOtherModel: false, otherModel: undefined, isOtherVariant: false, otherVariant: undefined });
      api('getConnectionRequestVehicleModelsByBrandId', id)
        .then(res => {
          const data = res.data;
          data.push({ id: 0, attributes: { name: this.props.translationsStore.translate('connectionRequests.newConnection.sectionVehicleData.labelOther') } });
          this.setState({models: data.map(model => ({id: model.id, name: model.attributes.name}))});
        })
        .catch(error => ({ error }))
        .finally(() => this.setState({ loadingResources: false }));
    } else {
      this.setState({ isOtherBrand: true, otherBrand: undefined, isOtherModel: true, otherModel: undefined, isOtherVariant: true, otherVariant: undefined });
      let models = [{ id: 0, name: this.props.translationsStore.translate('connectionRequests.newConnection.sectionVehicleData.labelOther') }];
      this.setState({ models, loadingResources: false });
    }
  };

  onOtherBrandChange = e => {
    this.setState({ ...this.state, otherBrand: e.target.value });
  };

  validModel = () => {
    if (this.state.isOtherModel === true && this.state.otherModel !== undefined && this.state.otherModel !== '') {
      return true;
    } else if (this.state.isOtherModel === false && this.state.model !== undefined) {
      return true;
    } else {
      return false;
    }
  }

  onModelChange = model => {
    this.setState({ loadingResources: true, model: JSON.parse(model), variants: undefined, variant: undefined });
    const { id, name } = JSON.parse(model);
    if (name !== this.props.translationsStore.translate('connectionRequests.newConnection.sectionVehicleData.labelOther')) {
      this.setState({ isOtherModel: false, otherModel: undefined, isOtherVariant: false, otherVariant: undefined });
      api('getConnectionRequestVehicleVariantsByModelId', id)
        .then(variants => {
          variants.data.push({ id: 0, attributes: { name: this.props.translationsStore.translate('connectionRequests.newConnection.sectionVehicleData.labelOther') } });
          this.setState({variants: variants.data.map(variant => ({id: variant.id, name: variant.attributes.name}))});
        })
        .catch(error => ({ error }))
        .finally(() => this.setState({ loadingResources: false }));
    } else {
      this.setState({ isOtherModel: true, otherModel: undefined, isOtherVariant: true, otherVariant: undefined });
      let variants = [{ id: 0, name: this.props.translationsStore.translate('connectionRequests.newConnection.sectionVehicleData.labelOther') }];
      this.setState({variants, loadingResources: false});
    }
  };

  onOtherModelChange = e => {
    this.setState({ ...this.state, otherModel: e.target.value });
  };

  validVariant = () => {
    if (this.state.isOtherVariant === true && this.state.otherVariant !== undefined && this.state.otherVariant !== '') {
      return true;
    } else if (this.state.isOtherVariant === false && this.state.variant !== undefined) {
      return true;
    } else {
      return false;
    }
  }

  onVariantChange = variant => {
    const { id, name } = JSON.parse(variant);
    if (name !== this.props.translationsStore.translate('connectionRequests.newConnection.sectionVehicleData.labelOther')) {
      this.setState({ isOtherVariant: false, otherVariant: undefined });
      this.queryTechnicalDetails(id)
        .then(technicalDetails => {
          const { fuel_type, displacement } = technicalDetails;
          this.setState({ fuel_type, displacement });
        })
        .catch(error => ({ error }));
      this.setState({ variant: JSON.parse(variant) });
    } else {
      this.setState({ isOtherVariant: true, otherVariant: undefined });
      this.setState({ variant: JSON.parse(variant) });
    }
  };

  onOtherVariantChange = e => {
    this.setState({ ...this.state, otherVariant: e.target.value });
  };

  onFuelTypeChange = fuel_type => {
    this.setState({ fuel_type });
  };

  onRegistrationDateChange = registration_date => {
    this.setState({ registration_date: registration_date.format('YYYY-MM-DD') });
  };

  onVinChange = e => {
    this.setState({
      vin: e.target.value
    });
  };

  onDisplacementChange = e => {
    this.setState({
      displacement: e.target.value
    });
  };

  saveConnectionRequest = () => {
    const { connectionRequestsStore } = this.props;
    const { product_uuid, subscription_type_uuid, addOns, installer_uuid, availableProducts, availableSubscriptionTypes, availableInstallers, selectedSubscription, isOtherBrand, otherBrand, isOtherModel, otherModel, isOtherVariant, otherVariant } = this.state;
    const product = {
        uuid: product_uuid,
        name: (availableProducts.find(product => product.uuid === product_uuid) || {}).name,
        zuora_product_id: (availableProducts.find(product => product.uuid === product_uuid) || {}).zuora_product_id
      },
      subscriptionType = {
        uuid: subscription_type_uuid,
        name: (availableSubscriptionTypes.find(subscriptionType => subscriptionType.uuid === subscription_type_uuid) || {}).name
      },
      installer = availableInstallers.find(installer => installer.uuid === installer_uuid) || {};

    let connectionRequest = {
      vehicle: { ...pick(this.state, ['vin', 'license_plate', 'brand', 'model', 'variant', 'registration_date', 'fuel_type', 'displacement']), installer },
      addOns,
      product_uuid,
      subscription_type_uuid,
      installer_uuid,
      product,
      subscriptionType,
      selectedSubscription
    };
    if (isOtherBrand) {
      connectionRequest.vehicle.brand = { id: '0', name: otherBrand };
    }
    if (isOtherModel || isOtherBrand) {
      connectionRequest.vehicle.model = { id: '0', name: otherModel };
    }
    if (isOtherVariant || isOtherModel || isOtherBrand) {
      connectionRequest.vehicle.variant = { id: '0', name: otherVariant };
    }
    return connectionRequestsStore.addConnectionRequest(connectionRequest).then(()=>{
      this.props.subscriptionsStore.load();
    })
  };

  handleCancel = () => {
    isFunction(this.props.onCancel) && this.props.onCancel();
  };

  handleSave = () => {
    this.setState({ loadingResources: true });
    this.saveConnectionRequest()
      .then(value => {
        isFunction(this.props.onDone) && this.props.onDone();
      })
      .catch(error => {
        if (error.message) {
          this.setState({ modalError: error.message, visibleModalError: true });
        }
      })
      .finally(() => this.setState({ loadingResources: false }));
  };

  handleSaveAndCreateNew = () => {
    this.setState({ loadingResources: true });
    this.saveConnectionRequest()
      .then(value => {
        this.setState({
          ...this.defaultVehicleDataValues,
          selectedSubscription: undefined,
          isPortability: undefined,
          addOns: undefined
        });
        this.onProductChange(this.state.product_uuid)
      })
      .catch(error => {
        if (error.message) {
          this.setState({ modalError: error.message, visibleModalError: true });
        }
      })
      .finally(() => this.setState({ loadingResources: false }));
  };

  onUseFreeSubscription = selectedSubscription => {
    const portabilityProduct = this.state.allProducts.find(el => el.category === 'portability' &&  el.availability === 'fleet-customer');

    const addOns = [];
    if(selectedSubscription.products.length > 1) {
      addOns.push(selectedSubscription.products[1].uuid);
    }
    addOns.push(portabilityProduct.uuid);

    let availableAddOns = [];
    if (this.state.allProducts.find(el => el.uuid === selectedSubscription.products[0].uuid).features.some(feature => feature.name === 'engine-control')) {
      availableAddOns = this.state.allProducts.filter(el => el.category === 'add-on' && el.features.some(feature => feature.name === 'engine-control'));
    }

    let subTypeForSubscription;
    if (!this.state.availableSubscriptionTypesForProduct.find(subType => subType.uuid === selectedSubscription.subscriptionType.uuid)) {

      subTypeForSubscription = this.state.availableSubscriptionTypes.find(subType => subType.uuid === selectedSubscription.subscriptionType.uuid);
    }

    availableAddOns = [...availableAddOns, portabilityProduct];

    this.setState({
      subscription_type_uuid: selectedSubscription.subscriptionType.uuid,
      product_uuid: selectedSubscription.products[0].uuid,
      availableAddOns,
      addOns,
      selectedSubscription,
      isPortability: true,
      ...subTypeForSubscription && {availableSubscriptionTypesForProduct: [...this.state.availableSubscriptionTypesForProduct, subTypeForSubscription]}
    });
  };

  render() {
    const { translationsStore, subscriptionsStore } = this.props;
    const { loadingResources, availableProducts, availableSubscriptionTypesForProduct, availableAddOns, availableInstallers, visibleInstallerPicker, isPortability } = this.state;
    const cls = classNames({
      NewConnectionRequest: true
    });
    const optionsAddOns = availableAddOns.map(addOn => ({
      label: addOn.name,
      value: addOn.uuid,
      disabled: isPortability
    }));
    const clsInstallerPicker = classNames({
      InstallerPicker: true,
      visible: visibleInstallerPicker
    });
    const validPlate = /^[A-Za-z]{2}[0-9]{3}[A-Za-z]{2}$/.test(this.state.license_plate);
    const clsPlate = classNames({
      withError: !validPlate
    });
    const clsBrand = classNames({
      'has-error': !(this.validBrand())
    });
    const clsModel = classNames({
      'has-error': !(this.validModel())
    });
    const clsVariant = classNames({
      'has-error': !(this.validVariant())
    });
    const clsOtherBrand = classNames({
      'has-error': !(this.validBrand())
    });
    const clsOtherModel = classNames({
      'has-error': !(this.validModel())
    });
    const clsOtherVariant = classNames({
      'has-error': !(this.validVariant())
    });
    const validDisplacement = /^[0-9]{3,}$/.test(this.state.displacement);
    const clsDisplacement = classNames({
      withError: !validDisplacement,
      'has-error': this.state.displacement !== undefined && !validDisplacement
    });
    const canBeSaved =
      !!this.state.installer_uuid &&
      !!this.state.product_uuid &&
      !!this.state.subscription_type_uuid &&
      validPlate &&
      !!(this.validBrand()) &&
      !!(this.validModel()) &&
      !!(this.validVariant()) &&
      !!this.state.registration_date &&
      !!this.state.vin &&
      !!this.state.fuel_type &&
      validDisplacement;

    return (
      <Fragment>
        <AirModalTitlebar
          className={cls}
          visible={this.props.hasOwnProperty('visible') ? this.props.visible : true}
          onCancel={this.handleCancel}
          title={translationsStore.translate('connectionRequests.newConnection.labelNewConnection')}
          titlebarStyle={{ color: 'white', backgroundColor: 'var(--selected-color)' }}
          buttonsStyle={{ display: 'none' }}
          width={900}
        >
          <Spin spinning={loadingResources || subscriptionsStore.loading}>
            <div className="NewConnectionRequestWrapper">
              <div className="NewConnectionRequestIntro">
                <VehicleAddIcon style={{ width: '42px', height: '42px' }} />
              </div>
              <NewConnectionRequestSection
                title={
                  <div style={{display: "flex"}}>
                    {translationsStore.translate('connectionRequests.newConnection.sectionService.title')}
                    {subscriptionsStore.freeSubscriptions.length > 0 && <FreeSubscriptionPicker onUseFreeSubscription={this.onUseFreeSubscription}/>}
                  </div>
                }
              >
                <RequestSelect
                  label={translationsStore.translate('connectionRequests.newConnection.sectionService.placeholderProduct')}
                  value={this.state.product_uuid}
                  onChange={this.onProductChange}
                  dropdownMatchSelectWidth={false}
                  disabled={isPortability}
                >
                  {availableProducts.map(product => (
                    <Option key={product.uuid} value={product.uuid}>
                      {product.name}
                    </Option>
                  ))}
                </RequestSelect>
                <RequestSelect
                  label={translationsStore.translate('connectionRequests.newConnection.sectionService.placeholderSubscriptionType')}
                  value={this.state.subscription_type_uuid}
                  onChange={this.onSubscriptionTypeChange}
                  dropdownMatchSelectWidth={false}
                  disabled={isPortability}
                >
                  {availableSubscriptionTypesForProduct.map(subscriptionType => (
                    <Option key={subscriptionType.uuid} value={subscriptionType.uuid}>
                      {translationsStore.translate(`connectionRequests.subscriptionTypes.${subscriptionType.name}`)}
                    </Option>
                  ))}
                </RequestSelect>
                <div>
                  { this.state.availableAddOns && this.state.availableAddOns.length > 0 &&
                  <React.Fragment>
                    <div style={{ marginTop: 8, color: 'var(--primary-color)', fontSize: 12, lineHeight: '15px' }}>
                      {translationsStore.translate('connectionRequests.newConnection.sectionService.optionAddServices')}
                    </div>
                    <Checkbox.Group options={optionsAddOns} onChange={this.onAddOnsChange} value={this.state.addOns} />
                  </React.Fragment>
                  }
                </div>
              </NewConnectionRequestSection>
              <NewConnectionRequestSection
                className="SectionFleetInstallation"
                title={translationsStore.translate('connectionRequests.newConnection.sectionFleetInstallation.title')}
              >
                <div />
                <RequestSelect
                  label={translationsStore.translate('connectionRequests.newConnection.sectionFleetInstallation.placeholderInstaller')}
                  value={this.state.installer_uuid}
                  onChange={this.onInstallerChange}
                  dropdownClassName={'InstallerDropdown'}
                  onDropdownVisibleChange={this.onInstallerVisibleChange}
                  getPopupContainer={() => document.getElementsByClassName('SectionFleetInstallation')[0]}
                  open={visibleInstallerPicker}
                  dropdownRender={menu => (
                    <InstallerPicker
                      getContainer={() => document.getElementsByClassName('InstallerDropdown')[0]}
                      className={clsInstallerPicker}
                      value={this.state.installer_uuid}
                      installers={availableInstallers}
                      onChange={this.onInstallerChange}
                      onCancel={this.onInstallerPickerCancel}
                      dropdownRenderMenu={menu}
                    />
                  )}
                >
                  {availableInstallers.map(installer => (
                    <Option key={installer.uuid} value={installer.uuid}>
                      {installer.name}
                    </Option>
                  ))}
                </RequestSelect>
              </NewConnectionRequestSection>
              <NewConnectionRequestSection className="SectionVehicleData" title={translationsStore.translate('connectionRequests.newConnection.sectionVehicleData.title')}>
                <AirInput
                  className={clsPlate}
                  label={translationsStore.translate('connectionRequests.newConnection.sectionVehicleData.placeholderPlate')}
                  value={this.state.license_plate}
                  onChange={this.onPlateChange}
                />
                <AirButton
                  disabled={!validPlate}
                  style={{ position: 'absolute', top: 40, left: 190 }}
                  bgcolor={validPlate ? `var(--primary-color)` : `var(--grey)`}
                  light="true"
                  icon={
                    <Tooltip title={translationsStore.translate('connectionRequests.newConnection.labelQueryPlate')}>
                      <VehicleAddIcon style={{ width: '16px', height: '16px' }} />
                    </Tooltip>
                  }
                  onClick={this.onPlateQueryClick}
                />
                {this.state.brands ? (
                  <RequestSelect
                    className={clsBrand}
                    label={translationsStore.translate('connectionRequests.newConnection.sectionVehicleData.placeholderMake')}
                    value={JSON.stringify(this.state.brand)}
                    onChange={this.onBrandChange}
                    dropdownMatchSelectWidth={false}
                    showArrow={(this.state.brands || []).length > 1}
                    optionFilterProp="name"
                    dropdownRender={menu => ((this.state.brands || []).length > 1 ? menu : <Fragment />)}
                  >
                    {(this.state.brands || []).map((brand, index) => (
                      <Option key={index} value={JSON.stringify(brand)} name={`${brand.name}`}>
                        {brand.name}
                      </Option>
                    ))}
                  </RequestSelect>
                ) : (
                  <AirInput
                    label={translationsStore.translate('connectionRequests.newConnection.sectionVehicleData.placeholderMake')}
                    value={this.state.brand && this.state.brand.hasOwnProperty('name') ? this.state.brand.name : ''}
                    readOnly
                  />
                )}
                {this.state.isOtherBrand && (
                  <AirInput
                  className={clsOtherBrand}
                  label={translationsStore.translate('connectionRequests.newConnection.sectionVehicleData.placeholderOtherMake')}
                    value={this.state.otherBrand}
                    onChange={this.onOtherBrandChange}
                  />
                )}
                {this.state.models && !this.state.isOtherBrand ? (
                  <RequestSelect
                    className={clsModel}
                    label={translationsStore.translate('connectionRequests.newConnection.sectionVehicleData.placeholderModel')}
                    value={JSON.stringify(this.state.model)}
                    onChange={this.onModelChange}
                    dropdownMatchSelectWidth={false}
                    showArrow={true}
                    optionFilterProp="name"
                    disabled={this.state.isOtherBrand}
                  >
                    {(this.state.models || []).map((model, index) => (
                      <Option key={index} value={JSON.stringify(model)} name={`${model.name}`}>
                        {model.name}
                      </Option>
                    ))}
                  </RequestSelect>
                ) : (!this.state.isOtherBrand) ? (
                  <AirInput
                    label={translationsStore.translate('connectionRequests.newConnection.sectionVehicleData.placeholderModel')}
                    value={this.state.model && this.state.model.hasOwnProperty('name') ? this.state.model.name : ''}
                    readOnly
                  />
                ) : (
                  ''
                )}
                {(this.state.isOtherModel || this.state.isOtherBrand) && (
                  <AirInput
                  className={clsOtherModel}
                  label={translationsStore.translate('connectionRequests.newConnection.sectionVehicleData.placeholderOtherModel')}
                    value={this.state.otherModel}
                    onChange={this.onOtherModelChange}
                  />
                )}
                {this.state.variants && !this.state.isOtherModel && !this.state.isOtherBrand ? (
                <RequestSelect
                  className={clsVariant}
                  label={translationsStore.translate('connectionRequests.newConnection.sectionVehicleData.placeholderVariant')}
                  value={JSON.stringify(this.state.variant)}
                  onChange={this.onVariantChange}
                  dropdownMatchSelectWidth={false}
                  showArrow={(this.state.variants || []).length > 1}
                  optionFilterProp="name"
                  dropdownRender={menu => ((this.state.variants || []).length > 1 ? menu : <Fragment />)}
                  disabled={this.state.isOtherBrand || this.state.isOtherModel}
                >
                  {(this.state.variants || []).map((variant, index) => (
                    <Option key={index} value={JSON.stringify(variant)} name={`${variant.name}`}>
                      {variant.name}
                    </Option>
                  ))}
                </RequestSelect>
                ) : (!this.state.isOtherModel && !this.state.isOtherBrand) ? (
                  <AirInput
                    label={translationsStore.translate('connectionRequests.newConnection.sectionVehicleData.placeholderVariant')}
                    value={this.state.variant && this.state.variant.hasOwnProperty('name') ? this.state.variant.name : ''}
                    readOnly
                  />
                ) : (
                  ''
                )}
                {(this.state.isOtherModel || this.state.isOtherBrand || this.state.isOtherVariant) && (
                  <AirInput
                  className={clsOtherVariant}
                  label={translationsStore.translate('connectionRequests.newConnection.sectionVehicleData.placeholderOtherVariant')}
                    value={this.state.otherVariant}
                    onChange={this.onOtherVariantChange}
                  />
                )}
                {this.state.brands ? (
                  <AirInput
                    type="date"
                    label={translationsStore.translate('connectionRequests.newConnection.sectionVehicleData.placeholderFirstRegistrationDate')}
                    onChange={this.onRegistrationDateChange}
                    format={"DD/MM/YYYY"}
                    value={this.state.registration_date && moment(this.state.registration_date)}
                  />
                  ) : (
                  <AirInput
                    label={translationsStore.translate('connectionRequests.newConnection.sectionVehicleData.placeholderFirstRegistrationDate')}
                    value={this.state.registration_date && moment(this.state.registration_date).format('DD/MM/YYYY')}
                    readOnly
                  />
                  )
                }
                <AirInput
                  label={translationsStore.translate('connectionRequests.newConnection.sectionVehicleData.placeholderVin')}
                  value={this.state.vin}
                  onChange={this.onVinChange}
                  readOnly={!this.state.brands}
                />
                <RequestSelect
                  label={translationsStore.translate('connectionRequests.newConnection.sectionVehicleData.placeholderAlimentation')}
                  value={this.state.fuel_type}
                  onChange={this.onFuelTypeChange}
                  dropdownMatchSelectWidth={false}
                >
                  {this.state.availableFuelType.map((fuel_type, index) => (
                    <Option key={index} value={fuel_type}>
                      {translationsStore.translate(`alimentation.${fuel_type}`)}
                    </Option>
                  ))}
                </RequestSelect>
                <AirInput
                  className={clsDisplacement}
                  label={translationsStore.translate('connectionRequests.newConnection.sectionVehicleData.placeholderDisplacement')}
                  value={this.state.displacement}
                  onChange={this.onDisplacementChange}
                />
                <div />
              </NewConnectionRequestSection>
              <div className="NewConnectionRequestActions">
                <AirButton
                  className="ActionSave"
                  size="large"
                  light="true"
                  label={translationsStore.translate('connectionRequests.newConnection.actionSave')}
                  onClick={this.handleSave}
                  disabled={!canBeSaved}
                  bgcolor={canBeSaved ? `var(--primary-color)` : `var(--grey)`}
                />
                <AirButton
                  className="ActionSaveAndCreateNew"
                  size="large"
                  light="true"
                  label={translationsStore.translate('connectionRequests.newConnection.actionSaveAndCreateNew')}
                  onClick={this.handleSaveAndCreateNew}
                  disabled={!canBeSaved}
                  bgcolor={canBeSaved ? `var(--primary-color)` : `var(--grey)`}
                />
              </div>
            </div>
          </Spin>
        </AirModalTitlebar>
        <AirModalTitlebar
          visible={this.state.visibleModalError}
          okButton={<AirButton size="large" light="true" label={'Ok'} style={{ marginLeft: 20, width: 240 }} />}
          onOk={() => this.setState({ modalError: undefined, visibleModalError: false })}
          title={translationsStore.translate('connectionRequests.newConnection.titleErrorOnSave')}
          titlebarStyle={{ color: 'white', backgroundColor: 'var(--red-dtc-color)' }}
          buttonsStyle={{ justifyContent: 'center' }}
          width={300}
        >
          <div style={{ margin: 14 }}>
            {translationsStore.translate('connectionRequests.newConnection.labelErrorOnSave')}
            <br />
            {this.state.modalError}
          </div>
        </AirModalTitlebar>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ConnectionRequestsDashboard/NewConnectionRequest/NewConnectionRequest.js